export default {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  REJECTED: 'Rejected',
  REVERSED: 'Reversed',
  PROCESSING: 'Processing',
  AUTHORIZED: 'Authorized',
  APPROVED: 'Approved',
  AWAITING_APPROVAL: 'Waiting for Approval',
};
